import request from '../api';

// 搜索
export function multiMediaSearch(data) {
  return request.post('/app/multiMedia/search', data);
}

// 音频
export function multiMediaAudio(data) {
  return request.post('/app/multiMedia/audio', data);
}

// 剪辑
export function multiMediaClip(data) {
  return request.post('/app/ai/edit/videoEditing', data);
}

// 获取剪辑结果
export function multiMediaClipProgress(taskId) {
  return request.get(`/app/ai/edit/progress/${taskId}`);
}

// 添加多媒体素材
export function multiMediaAddMultiMedia(data) {
  return request.post('/app/multiMedia/addMultiMedia', data);
}

// 删除多媒体素材
export function deleteMultiMedia(id) {
  return request.post(`/app/multiMedia/deleteMultiMedia/${id}`);
}

// 更新多媒体素材
export function multiMediaUpdateMultiMedia(data) {
  return request.post('/app/multiMedia/updateMultiMedia', data);
}

// 搜索资源
/**
 *  视频：1，文字：2，背景：3，音频：4，装饰：5
 * @param data
 * @returns
 */
export function searchMedia(data) {
  return request({
    url: '/app/multiMedia/searchMedia',
    method: 'post',
    data,
  });
}
